import { fieldCannotBeEmpty, MAX_LENGTH } from 'constants/messages'

export const PRODUCT_RULES = {
  title: {
    required: { value: true, message: fieldCannotBeEmpty },
    maxLength: {
      value: 32,
      message: MAX_LENGTH('Product name', 32),
    },
  },

  details: {
    maxLength: {
      value: 3000,
      message: MAX_LENGTH('Details', 3000),
    },
  },

  description: {
    maxLength: {
      value: 600,
      message: MAX_LENGTH('Description', 600),
    },
  },

  // OPTIONAL (2026-08-21). A manufacture date is frequently not known at the point a
  // product is created — it is a fact about a physical run, not about the catalogue
  // entry — so requiring it blocked creation on information the person filling the form
  // often does not have. No `required` key at all rather than `required: false`, so
  // react-hook-form registers no validator for it.
  //
  // Reached independently from the URL importer (VRG-353), where it is the sharper
  // case: a listing page never publishes a manufacture date, so requiring one invited
  // a made-up value on the record whose entire purpose is provenance. Better empty
  // than wrong.
  manufacture_date: {},

  sku: {
    required: { value: true, message: fieldCannotBeEmpty },
  },

  // Optional — but if a value is entered it must be a valid URL.
  product_url: {
    pattern: {
      value: /^https?:\/\/[^\s/$.?#].[^\s]*$/i,
      message: 'Enter a valid URL (e.g. https://example.com/product)',
    },
  },

  quantity: {
    required: fieldCannotBeEmpty,
    valueAsNumber: true,
    min: {
      value: 0,
      message: 'Quantity cannot be negative',
    },
    max: {
      value: 9999,
      message: 'Quantity cannot be more than 9999',
    },
  },
}

export const COMPANY_RULES = {
  name: {
    required: { value: true, message: fieldCannotBeEmpty },
    maxLength: {
      value: 64,
      message: MAX_LENGTH('Company name', 64),
    },
  },
}
